import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-brand-500 animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Role-based redirection
  if (user?.role === 'celular' && location.pathname !== '/mobile-portal') {
    return <Navigate to="/mobile-portal" replace />;
  }

  if (user?.role !== 'celular' && location.pathname === '/mobile-portal') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};